import {
  cancelUpdateHoveredShapeId,
  updateHoveredShapeId
} from "./tools/selection-logic/updateHoveredShapeId.mjs";
function registerDefaultSideEffects(editor) {
  const resolveEmbedAspectRatio = (shape) => {
    ;
    editor.getShapeUtil("embed").resolveAspectRatio(shape);
  };
  const unsub = editor.sideEffects.register({
    shape: {
      afterCreate: (shape, source) => {
        if (source !== "user") return;
        if (editor.isShapeOfType(shape, "embed")) {
          resolveEmbedAspectRatio(shape);
        }
      },
      afterChange: (prev, next, source) => {
        if (source !== "user") return;
        if (editor.isShapeOfType(next, "embed") && prev.props.url !== next.props.url) {
          resolveEmbedAspectRatio(next);
        }
      }
    },
    instance: {
      afterChange: (prev, next) => {
        if (prev.cameraState !== next.cameraState && next.cameraState === "idle") {
          updateHoveredShapeId(editor);
        }
      }
    },
    instance_page_state: {
      afterChange: (prev, next) => {
        if (prev.croppingShapeId !== next.croppingShapeId) {
          const isInCroppingState = editor.isIn("select.crop");
          if (!prev.croppingShapeId && next.croppingShapeId) {
            if (!isInCroppingState) {
              editor.setCurrentTool("select.crop.idle");
            }
          } else if (prev.croppingShapeId && !next.croppingShapeId) {
            if (isInCroppingState) {
              editor.setCurrentTool("select.idle");
            }
          }
        }
        if (prev.editingShapeId !== next.editingShapeId) {
          if (!prev.editingShapeId && next.editingShapeId) {
            if (!editor.isIn("select.editing_shape")) {
              const shape = editor.getEditingShape();
              if (shape && shape.type === "text" && editor.isInAny("text.pointing", "select.resizing") && editor.getInstanceState().isToolLocked) {
                editor.setCurrentTool("select.editing_shape", {
                  target: "shape",
                  shape,
                  isCreatingTextWhileToolLocked: true
                });
              } else {
                editor.setCurrentTool("select.editing_shape", {
                  target: "shape",
                  shape
                });
              }
            }
          } else if (prev.editingShapeId && !next.editingShapeId) {
            if (editor.isIn("select.editing_shape")) {
              editor.setCurrentTool("select.idle");
            }
          }
        }
      }
    }
  });
  return () => {
    unsub();
    cancelUpdateHoveredShapeId(editor);
  };
}
export {
  registerDefaultSideEffects
};
//# sourceMappingURL=defaultSideEffects.mjs.map
